import {
  AGENT_SPACES_BASE_URL,
  getFusionAssistantBeaconUrl,
} from './constants';

/**
 * Builds the AgentSpaces URL that opens the Fusion Assistant with the given
 * prompt already typed in. The prompt is URL-encoded so text containing `&`,
 * `#` or `+` cannot alter the other query parameters.
 */
export const buildAgentSpacesDeepLink = (prompt: string): string =>
  `${AGENT_SPACES_BASE_URL}&initialPrompt=${encodeURIComponent(prompt)}`;

/**
 * Records that someone opened the Fusion Assistant, so adoption can be tracked
 * the same way the documentation-page entry point tracks it: a fire-and-forget
 * image request. Pipes replace slashes because the beacon encodes the page and
 * alias as a single path segment pair.
 *
 * Both values are then URL-encoded before going into the image src. This app
 * uses hash-based routing, so `location.href` normally contains a `#`; without
 * encoding, everything from the `#` onward (including the `/${who}` suffix) is
 * treated as a URL fragment and never sent to the server, so the beacon would
 * record neither the real page nor the alias. Encoding also neutralizes spaces
 * and any other characters that could break the request.
 *
 * Never throws and never blocks — the click must navigate whether or not the
 * beacon succeeds.
 */
export const fireFusionAssistantBeacon = (alias: string | null): void => {
  try {
    const page = encodeURIComponent(location.href.replace(/\//g, '|'));
    const who = encodeURIComponent((alias || 'unknown').replace(/\|/g, '_'));
    new Image().src = `${getFusionAssistantBeaconUrl()}${page}/${who}`;
  } catch {
    // Adoption metrics are best-effort; a beacon failure must be invisible.
  }
};
